/*
 * @Author: lyy 2896768658@qq.com
 * @Date: 2023-10-18 09:08:27
 * @LastEditors: lyy 2896768658@qq.com
 * @LastEditTime: 2023-10-18 09:34:16
 * @FilePath: \zljt-bigdata-web\src\store\dataManage.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const commonIcon = {
  excel: '/static/imgs/source/excel-v2.png',
  csv: '/static/imgs/source/csv-v2.png',
  txt: '/static/imgs/source/txt-v2.png',
  mdb: '/static/imgs/source/mdb-v2.png',
  word: '/static/imgs/source/word-v2.png',
  img: '/static/imgs/source/image-v2.png',
  pdf: '/static/imgs/source/pdf-v2.png',
  mysql: '/static/imgs/source/mysql.png',
  sqlserver: '/static/imgs/source/sqlserve.png',
  clickhouse: '/static/imgs/source/clickHouse.png',
  hbase: '/static/imgs/source/Hbase.png',
  bigdata: '/static/imgs/source/bigdata.png',
  file: '/static/imgs/source/folder.png',
  table: '/static/imgs/source/table.png',
  // etlout: '/static/imgs/source/etloutNew.svg',
  etlout: '/static/imgs/source/yiqingxi.png',
  etlsource: '/static/imgs/source/etlcourseNew.png',
  etlcheck: '/static/imgs/source/etlcheckNew.svg',
  code: '/static/imgs/source/newCode.png',
  jupyter: '/static/imgs/source/newJupyter.png',
  analyseSql: '/static/imgs/source/Analyse_sql.svg',
  // collection: '/static/imgs/source/excelNew.png',
  collection: '/static/imgs/source/weiqingxi.png', // 未清洗
  shujuji: '/static/imgs/source/shujuji.png', // 数据集
  bi: '/static/imgs/source/bi.png', // bi
  baobiao: '/static/imgs/source/baobiao.png', // 报表
  bianchengkeshihua: '/static/imgs/source/bianchengkeshihua.png', // 编程可视化
  shujubaogao: '/static/imgs/source/shujubaogao.png', // 数据报告
  suanfafenxi: '/static/imgs/source/suanfafenxi.png', // 算法分析
}
export default {
  namespaced: true,
  state: {
    dataSourceList: ['自行生产', '协议取得', '公共数据', '其他方式'],
    commonIcon,
    allListType: [
      {
        key: 'file',
        typeName: '文件数据上传',
        newtypeListNoFile: [//上传类型列表
          { type: 'excel', sourceTxt: '表格类', typeCode: 1, name: "Excel", desc: '支持*.xlsx格式', pic: commonIcon.excel, descDetail: '用于上传具有复杂数据和公式的电子表格文件，适合数据分析和报表制作' },
          { type: 'csv', sourceTxt: '表格类', typeCode: 6, name: "CSV", desc: '支持*.csv格式', color: "rgba(96, 184, 27, 1)", pic: commonIcon.csv, descDetail: '适用于上传简洁的文本数据，常用于数据导入导出，易于处理大量数据'},
          { type: 'txt', sourceTxt: '文档类', typeCode: 5, name: "TxT", desc: '支持*.txt格式', pic: commonIcon.txt, descDetail: '适用于上传非格式化的纯文本文件，常用于日志信息、配置文件等简单文本存储' },
          { type: 'mdb', sourceTxt: '表格类', typeCode: 3, name: "MDB", desc: '支持*.mdb格式', pic: commonIcon.mdb, descDetail: '用于上传Microsoft Access数据库文件，适合包含结构化数据的应用场景' },
          { type: 'word', sourceTxt: '文档类', typeCode: 4, name: "Word", desc: '支持*.doc, *.docx格式', pic: commonIcon.word, descDetail: '用于上传格式化的文档文件，包括文字、图像、表格等，适合文档编辑和印刷' },
          { type: 'img', sourceTxt: '图片', typeCode: 2, name: "图片", desc: '支持单张图片最大8M', pic: commonIcon.img, descDetail: '支持jpg、jpeg、png、bmp、gif、tiff格式，用于上传图像文件，适用于照片、图形设计、网页元素等视觉内容的展示' },
          { type: 'PDF', sourceTxt: 'PDF', typeCode: 7, name: "PDF", desc: '支持*.pdf格式', pic: commonIcon.pdf, descDetail: '用于上传固定格式的文档，保持在不同设备和平台上的格式一致性' },
        ],
      },
      {
        key: 'database',
        typeName: '数据库连接',
        newtypeListNoFile: [
          {
            type: '原始数据库',
            // TODO 新增，需要和后端确认
            typeCode: 16,
            name: '原始数据库',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.bigdata,
            desc: '中联沉淀数据，已脱敏',
            descDetail: '包含大量原始数据记录，适用于数据预处理、挖掘和分析'
            ,sourceTxt: '数据港'
          },
          {
            type: '标准数据库',
            typeCode: 12,
            name: '标准数据库',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.bigdata,
            desc: '已规范化处理的数据库文件',
            descDetail: '结构更清晰，便于进行挖掘与分析'
            ,sourceTxt: '数据港'
          },


          // {
          //   type: '金融数据库',
          //   typeCode: 12,
          //   name: '金融数据库',
          //   color: "rgba(96, 184, 27, 1)",
          //   pic: commonIcon.bigdata,
          //   desc: '创建金融数据库'
          //   ,sourceTxt: ''
          // },
          {
            type: 'mysql',
            typeCode: 8,
            name: 'MySQL',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.mysql,
            desc: '',
            descDetail: '适用于上传MySQL数据库的文件，广泛用于网站和在线应用服务的数据存储，支持大规模的数据处理'
            ,sourceTxt: '关系型数据库'
          },
          {
            type: 'sqlserver',
            typeCode: 9,
            name: 'SQL Server',
            color: "rgba(96, 184, 27, 1)",
            pic:commonIcon.sqlserver,
            desc: '',
            descDetail: '用于上传Microsoft SQL Server的数据库文件，适合企业级的应用，支持复杂的事务处理和查询操作'
            ,sourceTxt: '关系型数据库'
          },
          {
            type: 'clickhouse',
            typeCode: 10,
            name: 'Clickhouse',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.clickhouse,
            desc: '',
            descDetail: '用于上传ClickHouseV2的数据库文件，特别适合在线分析处理（OLAP）和处理大规模数据集'
            ,sourceTxt: '关系型数据库'
          },
          {
            type: 'mongodb',
            typeCode: 14,
            name: 'MongoDB',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.clickhouse,
            desc: '',
            descDetail: '适用于上传MongoDB的文档型数据库文件，优秀的水平扩展能力，适合处理大量的结构化或半结构化数据'
            ,sourceTxt: 'NoSQL'
          },
          {
            // TODO 先展示出来，后期做
            type: 'searchdsl',
            typeCode: 20,
            name: 'ElasticSearchDSL',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.clickhouse,
            desc: '',
            descDetail: '用于上传ElasticSearch的数据文件，主要适用于快速搜索、实时分析和日志聚合等场景'
            ,sourceTxt: 'NoSQL'
          },
          {
            // TODO 先展示出来，后期做
            type: 'influxdb',
            typeCode: 21,
            name: 'InfluxDB',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.clickhouse,
            desc: '',
            descDetail: '适用于上传InfluxDB的时间序列数据库文件，特别适合物联网、实时分析和监控应用'
            ,sourceTxt: 'NoSQL'
          },
          {
            // TODO 先展示出来，后期做
            type: 'ODBC',
            typeCode: 22,
            name: 'ODBC',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.clickhouse,
            desc: '(Open Database Connectivity)',
            descDetail: '用于上传支持ODBC标准的数据库文件，使各种数据库产品之间可以实现互操作性和数据交换'
            ,sourceTxt: '开放式数据库'
          },
          {
            type: 'hbase',
            typeCode: 11,
            name: 'HBase',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.hbase,
            desc: '创建分布式数据库',
            descDetail: '适用于上传HBase的数据库文件，适合海量数据的存储和实时读写操作'
            ,sourceTxt: 'NoSQL'
          },
        ],
      },
      {
        key: 'program',
        typeName: '编程采集',
        newtypeListNoFile: [
          { type: 'py', sourceTxt: '全代码操作', typeCode: 13, name: "代码块", desc: '', descDetail: '适用于上传代码编辑器的配置文件或扩展插件。代码编辑器是程序员编写、查看和编辑源代码的工具，支持多种编程语言，并提供语法高亮、代码补全等功能', pic: commonIcon.code },
          // { type: 'crawler', sourceTxt: '可视化操作', typeCode: 32, name: "可视化爬虫工具", desc: '', descDetail: '适用于上传代码编辑器的配置文件或扩展插件。代码编辑器是程序员编写、查看和编辑源代码的工具，支持多种编程语言，并提供语法高亮、代码补全等功能', pic: commonIcon.code },
        ]
      }
    ],
    tmListType: [
      {
        typeName: '文件类型',
        newtypeListNoFile: [//上传类型列表
          { type: 'excel', typeCode: 1, name: "Excel", desc: '通过Excel文件生成', pic: commonIcon.excel },
          // {type: 'csv', typeCode: 6, name: "CSV", desc:'通过TXT文件生成',color: "rgba(96, 184, 27, 1)", pic: commonIcon.csv},
        ],
      },
    ],

    typeListNoFile: [//上传类型列表
      { type: 'excel', typeCode: 1, name: "Excel", color: "rgba(96, 184, 27, 1)", pic: commonIcon.excel },
      { type: 'csv', typeCode: 6, name: "CSV", color: "rgba(210, 70, 37, 1)", pic: commonIcon.csv },
      { type: 'txt', typeCode: 5, name: "TxT", color: "rgba(159, 172, 224, 1)", pic: commonIcon.txt },
      { type: 'mdb', typeCode: 3, name: "MDB", color: "rgba(255, 189, 18, 1) ", pic: commonIcon.mdb },
      { type: 'word', typeCode: 4, name: "Word", color: "rgba(42, 86, 153, 1)", pic: commonIcon.word },
      { type: 'img', typeCode: 2, name: "图片", color: "rgba(91, 206, 245, 1)", pic: commonIcon.img },
      { type: 'PDF', typeCode: 7, name: "PDF", color: "rgba(210, 70, 37, 1)", pic: commonIcon.pdf },
      // {type: 'mysql',typeCode: 8,name: 'MySQL',color: "rgba(96, 184, 27, 1)", pic: commonIcon.mysql},
      // {type: 'sqlserver',typeCode: 9,name: 'SQL Server',color: "rgba(96, 184, 27, 1)", pic:commonIcon.sqlserver},
    ],
    typeList: [//表格展示类型列表
      { type: 'excel', typeCode: 1, name: "Excel", color: "rgba(96, 184, 27, 1)", pic: commonIcon.excel },
      { type: 'csv', typeCode: 6, name: "CSV", color: "rgba(210, 70, 37, 1)", pic: commonIcon.csv },
      { type: 'txt', typeCode: 5, name: "TxT", color: "rgba(159, 172, 224, 1)", pic: commonIcon.txt },
      { type: 'mdb', typeCode: 3, name: "MDB", color: "rgba(255, 189, 18, 1) ", pic: commonIcon.mdb },
      { type: 'word', typeCode: 4, name: "Word", color: "rgba(42, 86, 153, 1)", pic: commonIcon.word },
      { type: 'img', typeCode: 2, name: "图片", color: "rgba(91, 206, 245, 1)", pic: commonIcon.img },
      { type: 'file', typeCode: 0, name: "文件", color: "rgba(91, 206, 245, 1)", pic: commonIcon.file },
      { type: 'PDF', typeCode: 7, name: "PDF", color: "rgba(210, 70, 37, 1)", pic: commonIcon.pdf },
      { type: 'mysql', typeCode: 8, name: 'MySQL', color: "rgba(96, 184, 27, 1)", pic: commonIcon.mysql },
      {
        type: 'sqlserver',
        typeCode: 9,
        name: 'SQL Server',
        color: "rgba(96, 184, 27, 1)",
        pic:commonIcon.sqlserver
      },
      {
        type: 'clickhouse',
        typeCode: 10,
        name: 'Clickhouse',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.clickhouse
      },
      { type: 'hbase', typeCode: 11, name: 'HBase', color: "rgba(96, 184, 27, 1)", pic: commonIcon.hbase },
      {
        type: '金融数据库',
        typeCode: 12,
        name: '金融数据库',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.bigdata
      },
      {
        type: 'spider',
        typeCode: 13,
        name: 'spider',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.code
      },
    ],
    newtypeList: [//表格展示类型列表
      { type: 'excel', typeCode: 1, name: "Excel", color: "rgba(96, 184, 27, 1)", pic: commonIcon.excel },
      { type: 'csv', typeCode: 6, name: "CSV", color: "rgba(210, 70, 37, 1)", pic: commonIcon.csv },
      { type: 'txt', typeCode: 5, name: "TxT", color: "rgba(159, 172, 224, 1)", pic: commonIcon.txt },
      { type: 'mdb', typeCode: 3, name: "MDB", color: "rgba(255, 189, 18, 1) ", pic: commonIcon.mdb },
      { type: 'word', typeCode: 4, name: "Word", color: "rgba(42, 86, 153, 1)", pic: commonIcon.word },
      { type: 'img', typeCode: 2, name: "图片", color: "rgba(91, 206, 245, 1)", pic: commonIcon.img },
      { type: 'file', typeCode: 0, name: "文件", color: "rgba(91, 206, 245, 1)", pic: commonIcon.file },
      { type: 'PDF', typeCode: 7, name: "PDF", color: "rgba(210, 70, 37, 1)", pic: commonIcon.pdf },
      { type: 'mysql', typeCode: 8, name: 'MySQL', color: "rgba(96, 184, 27, 1)", pic: commonIcon.mysql },
      {
        type: 'sqlserver',
        typeCode: 9,
        name: 'SQL Server',
        color: "rgba(96, 184, 27, 1)",
        pic:commonIcon.sqlserver
      },
      {
        type: 'clickhouse',
        typeCode: 10,
        name: 'Clickhouse',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.clickhouse
      },
      { type: 'hbase', typeCode: 11, name: 'HBase', color: "rgba(96, 184, 27, 1)", pic: commonIcon.hbase },
      {
        type: '金融数据库',
        typeCode: 12,
        name: '金融数据库',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.bigdata
      },
      {
        type: 'spider',
        typeCode: 13,
        name: 'spider',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.code
      },
    ],
    typeListNew: [//表格展示类型列表
      { type: 'excel', typeCode: 1, name: "Excel", color: "rgba(96, 184, 27, 1)", pic: commonIcon.collection },
      { type: 'csv', typeCode: 6, name: "CSV", color: "rgba(210, 70, 37, 1)", pic: commonIcon.csv },
      { type: 'txt', typeCode: 5, name: "TxT", color: "rgba(159, 172, 224, 1)", pic: commonIcon.txt },
      { type: 'mdb', typeCode: 3, name: "MDB", color: "rgba(255, 189, 18, 1) ", pic: commonIcon.mdb },
      { type: 'word', typeCode: 4, name: "Word", color: "rgba(42, 86, 153, 1)", pic: commonIcon.word },
      { type: 'img',  name: "图片", color: "rgba(91, 206, 245, 1)", pic: commonIcon.img },
      { type: 'file', typeCode: 0, name: "文件", color: "rgba(91, 206, 245, 1)", pic: commonIcon.file },
      { type: 'PDF', typeCode: 7, name: "PDF", color: "rgba(210, 70, 37, 1)", pic: commonIcon.pdf },
      { type: 'mysql', typeCode: 8, name: 'MySQL', color: "rgba(96, 184, 27, 1)", pic: commonIcon.mysql },
      {
        type: 'sqlserver',
        typeCode: 9,
        name: 'SQL Server',
        color: "rgba(96, 184, 27, 1)",
        pic:commonIcon.sqlserver
      },
      {
        type: 'clickhouse',
        typeCode: 10,
        name: 'Clickhouse',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.clickhouse
      },
      { type: 'hbase', typeCode: 11, name: 'HBase', color: "rgba(96, 184, 27, 1)", pic: commonIcon.hbase },
      {
        type: '金融数据库',
        typeCode: 12,
        name: '金融数据库',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.bigdata
      },
      {
        type: 'spider',
        typeCode: 13,
        name: 'spider',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.code
      },
    ],
    bloodTypeList: [//血缘类型列表
      { type: 'excel', typeCode: 1, name: "Excel", color: "rgba(96, 184, 27, 1)", pic: commonIcon.excel },
      { type: 'csv', typeCode: 6, name: "CSV", color: "rgba(210, 70, 37, 1)", pic: commonIcon.csv },
      { type: 'txt', typeCode: 5, name: "TxT", color: "rgba(159, 172, 224, 1)", pic: commonIcon.txt },
      { type: 'mdb', typeCode: 3, name: "MDB", color: "rgba(255, 189, 18, 1) ", pic: commonIcon.mdb },
      { type: 'word', typeCode: 4, name: "Word", color: "rgba(42, 86, 153, 1)", pic: commonIcon.word },
      { type: 'img', typeCode: 2, name: "图片", color: "rgba(91, 206, 245, 1)", pic: commonIcon.img },
      { type: 'file', typeCode: 0, name: "文件", color: "rgba(91, 206, 245, 1)", pic: commonIcon.file },
      { type: 'PDF', typeCode: 7, name: "PDF", color: "rgba(210, 70, 37, 1)", pic: commonIcon.pdf },
      { type: 'mysql', typeCode: 8, name: 'MySQL', color: "rgba(96, 184, 27, 1)", pic: commonIcon.mysql },
      {
        type: 'sqlserver',
        typeCode: 9,
        name: 'SQL Server',
        color: "rgba(96, 184, 27, 1)",
        pic:commonIcon.sqlserver
      },
      {
        type: 'clickhouse',
        typeCode: 10,
        name: 'Clickhouse',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.clickhouse
      },
      { type: 'hbase', typeCode: 11, name: 'HBase', color: "rgba(96, 184, 27, 1)", pic: commonIcon.hbase },
      {
        type: '数据集',
        typeCode: 100,
        name: 'SQL Server',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.table
      },
      {
        type: '金融数据库',
        typeCode: 12,
        name: '金融数据库',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.bigdata
      },
      {
        type: 'spider',
        typeCode: 13,
        name: 'spider',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.code
      },
      {
        type: '清洗数据',
        typeCode: 101,
        name: 'SQL Server',
        color: "rgba(96, 184, 27, 1)",
        pic: commonIcon.table
      },
    ],

    databaseType: [
      {
        typeName: '大数据库',
        list: [
          {
            type: '金融数据库',
            typeCode: 12,
            name: '金融数据库',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.bigdata
          },
        ]
      },
      {
        typeName: '关系型数据库',
        list: [
          {
            type: 'mysql',
            typeCode: 8,
            name: 'MySQL',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.mysql
          },
          {
            type: 'sqlserver',
            typeCode: 9,
            name: 'SQL Server',
            color: "rgba(96, 184, 27, 1)",
            pic:commonIcon.sqlserver
          },
        ]
      },
      {
        typeName: '分析型数据库',
        list: [
          {
            type: 'clickhouse',
            typeCode: 10,
            name: 'Clickhouse',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.clickhouse
          },
        ]
      },
      {
        typeName: '分布式数据库',
        list: [
          {
            type: 'hbase',
            typeCode: 11,
            name: 'HBase',
            color: "rgba(96, 184, 27, 1)",
            pic: commonIcon.hbase
          },
        ]
      },
    ],
    databaseTypeIds: [8, 9, 10, 11, 12],//数据库类型code list
    projectId: '',
    projectName: "",
    parentId: "",
    selectExcelObj: {},//结构化选区excel列表 {type: , documentIds: []}
    selectImgObj: {},//结构化选区img列表 {type: , documentIds: []}
    selectSheet: {},//选取的要编辑的表格 {documentId: 13,name: "工作簿1_副本.xlsx",sheetIndex: 1,sheetName: "Sheet2"}
    selectWordObj: {},//结构化选区word列表 {type: , documentIds: []}
    selectTxtObj: {},//结构化选区txt列表 {type: , documentIds: []}
    selectPdfObj: {}, //结构化选区pdf列表 {type: , documentIds: []}
    temporarilyAnalysisSheetHeadResp: [], //提交前临时数据
    temporarilySheetMapList: [],//提交前临时数据
    analysisSheetResp: {},//提交数据的行列及大小
    goBackBol: false,//返回上一页编辑唯一标识
    goBackIndex: -1,//返回上一页编辑唯一标识
    breadcrumbList: [],//数据源面包屑
    switchFlag: false,// 收起打开菜单
    structuredDetailId: null,
    objectInOperation: {},//右键菜单操作中对象
    alreadySubmitList: [],//临时存储的已提交的sheet表
    clearRules: [],//用户本地规则
    isClearJoin: false,//是否是数据清洗跳转到详情页
    isPriviewToBatch: false,//是否是预览跳入的结构化
    tableRowColumn: { //数据源预览行列
      row: 0,
      column: 0
    },
    templateGroupData: null,//按模板组结构化-选择的模板组
    mulSelectarr: [],
    isTmJoin: 1, //是否脱敏进入预览,
    selectAllFileMap: {}, // selectXXXObj的集合，type为key
  },
  mutations: {
    setData (state, data) {
      state[data.key] = data.value
    },
    setProjectId (state, data) {
      state.projectId = data
    },
    setParentId (state, data) {
      state.parentId = data
    },
    setProjectName (state, data) {
      state.projectName = data
    },
    setSelectExcelObj (state, data) {
      state.selectExcelObj = data
    },
    setSelectImgObj (state, data) {
      state.selectImgObj = data
    },
    setSelectSheet (state, data) {
      state.selectSheet = data
    },
    setSelectWordObj (state, data) {
      state.selectWordObj = data
    },
    setSelectTxtObj (state, data) {
      state.selectTxtObj = data
    },
    setSelectAllFileMap (state, data) {
      state.selectAllFileMap = data
    },
    setTemporarilyAnalysisSheetHeadResp (state, data) {
      state.temporarilyAnalysisSheetHeadResp = data
    },
    setTemporarilySheetMapList (state, data) {
      state.temporarilySheetMapList = data
    },
    setGoBackBol (state, data) {
      state.goBackBol = data
    },
    setSelectPdfObj (state, data) {
      state.selectPdfObj = data
      state.selectAllFileMap[data.type] = data
    },
  },
  getters: {
    ProjectNameAddSheetName (state) {
      if (state.databaseTypeIds.includes(state.selectExcelObj.type)) {
        return state.selectSheet.name
      }
      if (state.selectSheet.name && state.selectSheet.sheetName) {
        return state.selectSheet.name.split('.').slice(0, -1).join('') + '_' + state.selectSheet.sheetName
      }
      return ''
    },
    sourseType () {
      if (sessionStorage.getItem('soureId')) {
        return sessionStorage.getItem('soureId').split('_')[0]
      } else {
        return ''
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/dataManage.js